<template>
  <div class="container">
    <b-alert class="border border-dark w-100 my-4" show variant="danger">
      <h4 class="alert-heading">
        Error
      </h4>
      <div class="my-4">
        <p>{{ message }}</p>
      </div>
      <div class="call-for-support">
        <p>{{ getContentItem("PleaseContactUs") }}</p>
        <p class="d-flex align-items-center">
          <font-awesome-icon :icon="phoneIcon" size="2x" class="mr-2" />
          {{ tenantDetails.SupportPhoneNumber }}
        </p>
      </div>
    </b-alert>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  import { faPhoneSquareAlt } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

  export default {
    name: "Error",
    components: {
      FontAwesomeIcon,
    },
    props: {
      message: {
        type: String,
        default: "",
      },
    },
    data: () => ({
      phoneIcon: faPhoneSquareAlt,
    }),
    computed: {
      ...mapGetters(["getContentItem", "tenantDetails"]),
    },
  };
</script>
